import React from 'react';
import { SwapOutlined, CloudServerOutlined, UpCircleOutlined, DownCircleOutlined } from '@ant-design/icons';
import { UtilizationInventoryCard } from './UtilizationInventoryCard';
import { calculatePercentage, formatPercent } from '../../SummaryWrapper/inventorySummaryHelpers';
import { formatCount } from '../../../pages/Discovery/helpers';

export const ReadinessCard = ({
    readyForMigration,
    percentReady,
    totalInventory,
    totalOversizedVMs,
    totalUndersizedVMs,
    isExpanded,
    onFilterClick,
    ...props
}) => (
    <UtilizationInventoryCard
        title="Readiness"
        subLabelIcon={<SwapOutlined />}
        subLabelIconClass="success-icon"
        subLabel="Ready for Migration"
        primaryValue={formatCount(readyForMigration)}
        primaryPercent={`${percentReady}%`}
        description={'Instances meeting\nall thresholds'}
        onPrimaryClick={onFilterClick ? () => onFilterClick(['ready']) : undefined}
        rows={[
            {
                variant: 'ready',
                label: 'Total VMs',
                count: formatCount(totalInventory),
                icon: <CloudServerOutlined />,
            },
            {
                variant: 'warning',
                label: 'Oversized VMs',
                count: formatCount(totalOversizedVMs),
                percent: formatPercent(calculatePercentage(totalOversizedVMs, totalInventory)),
                iconVariant: 'notReady',
                icon: <UpCircleOutlined />,
            },
            {
                variant: 'warning',
                label: 'Undersized VMs',
                count: formatCount(totalUndersizedVMs),
                percent: formatPercent(calculatePercentage(totalUndersizedVMs, totalInventory)),
                icon: <DownCircleOutlined />,
            },
        ]}
        isExpanded={isExpanded}
        {...props}
    />
);
